<template>
  <div class="main">
    <Sidebar
      :current-keywords="keywords"
      :current-filters="currentFilters"
      :filter-types="filterTypes"
      @search="setKeywords"
      @add-filter="addFilter"
      @remove-filter="removeFilter"
      @remove-all-filters="removeAllFilters"
    />

    <div class="title-bar">
      <h1>Survey Submissions</h1>
      <a :href="route('admin.surveys.index')" class="btn-back">
          <span class="icon icon-arrow-left"></span> 
          <span class="text">Back to Survey List</span>
        </a>
      <AdminMenu class="pt-2" current="Forms" />
    </div>

    <div class="content p-3">
      <div class="row">
          <div class="col-12 mb-1 d-flex">
            <a
                v-if="items.length > 0"
                href="#"
                @click.prevent="showExportOptions()"
                class="btn btn-info"
            >
                <span class="icon icon-download"></span>
                <span class="text">Export List</span>
            </a>

            <a
                v-if="items.length > 0"
                href="#"
                @click.prevent="exportSummary()"
                class="btn btn-info ml-2"
            >
                <span class="icon icon-download"></span>
                <span class="text">Download PDF Summary</span>
            </a>

            <a
                v-if="items.length > 0"
                :href="route('admin.surveys.edit', { survey: survey.id })"
                class="btn btn-info ml-auto"
            >
                <span class="text">Edit Survey</span>
            </a>
          </div>
        <div class="col-12">
          <transition name="fade">
            <Alert v-if="hasAlert" :alert="alert" />
          </transition>
          <div class="row">
            <div class="col-12">
              <ListTable
                :items="items"
                :columns="columns"
                :activeColumns="activeColumns"
                :hideNoResults="hideNoResults"
                @sort-by="setSort"
                @swap-column="setActiveColumn"
              >
                <template v-slot:col_is_active="{ item }">{{ booleanColumn(item, "is_active") }}</template>
                <template v-slot:col_first_name="{item}">{{ item.first_name ? item.first_name : '-' }}</template>
                <template v-slot:col_last_name="{item}">{{ item.last_name ? item.last_name : '-' }}</template>
                <template v-slot:col_email="{item}">{{ item.email ? item.email : '-' }}</template>
                <template v-slot:list-menu="{ item, id }">
                  <ListMenu :item="item" :id="id" :eventBus="listEvents" />
                </template>
              </ListTable>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-xl-3">
            </div>
            <div class="col-12 col-xl-6 text-center">
              <Pagination
                class="d-inline-block"
                :total="totalPages"
                :value="parseInt(pagination.current)"
                @input="setCurrentPage"
              />
            </div>
            <div class="col-12 col-xl-3 text-center text-xl-right">
              <PageSize :value="parseInt(pagination.per_page)" @input="setPerPage" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import ListingMixin from "mixins/Listing";
import AdminMenu from "../../partials/AdminMenu";
import ListMenu from "./partials/ListMenu";
 
export default { 
  mixins: [DisplaysAlerts, ListingMixin],
  components: { AdminMenu, ListMenu },
  props: {
     survey: { type: Object | null }
  },
  methods: {
    delete(item) {
      if (confirm(`Are you sure you would like to remove this submission?`)) {
        this.axios
          .delete(this.route("admin.surveys.submissions.destroy", { submission: item.id }))
          .then(() => {
            this.refresh();
            this.showAlert("success", `The submission has been removed`, true);
          });
      }
    },
    handleMenuAction(action, item) {
      if (action === "remove") {
        this.delete(item);
      }
    },
    goBack() {

    }
  },
  mounted() {
    this.listEvents.$on("menu-action", this.handleMenuAction);
  }
};
</script>
